import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys } from "vue"

import { IonCol, IonGrid, IonIcon, IonRippleEffect, IonRow } from "@ionic/vue";
import { nextTick, ref, computed } from "vue";
import router from "@/router";
import { t } from "@/plugins/vue-i18n";

import CategoryPill from "@/components/various/CategoryPill.vue";
import ButtonBase from "@/components/button/ButtonBase.vue";
import InputSimple from "@/components/input/InputSimple.vue";

import { useListStore } from "@/stores/lists";

import { replaceToast } from "@/functions/baseToast";
import { popAlertConfirm } from "@/functions/alert";
import { stopEventAtTop } from "@/functions/modal";

import { CategoryTag } from "@/types/supplier";
import { PartiallyRequired } from "@/types/helper";
import { TagDropdownProps } from "@/types/props";

import { checkmark, close } from "ionicons/icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditTag',
  props: {
    listId: {},
    listItemId: {}
  },
  emits: ["update-item"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const listStore = useListStore()

const showEdit = ref<boolean>(false)
const tag = ref<CategoryTag>(new CategoryTag(''))
const searchAdd = ref<string>('')
const tagNameInput = ref()
const isDisabled = ref<boolean>(false)

const locationId = computed<string>(() => String(router.currentRoute.value.params.locationId))

const openEdit = (editTag: CategoryTag): void => {
    tag.value = JSON.parse(JSON.stringify(editTag))

    showEdit.value = true

    nextTick(() => tagNameInput.value.$el.children[0].setFocus())
}

const resetInput = (): void => {
    tag.value.name = ''
    tag.value.id = ''
    showEdit.value = false
}

const deleteHandler = async (tagId: string): Promise<void> => {
    const response = await listStore.deleteTag(locationId.value, tagId)

    if (!response) return

    listStore.isLoaded.recommendedTags = false
    listStore.getTags(locationId.value)
    await listStore.getListItem(locationId.value, props.listId, props.listItemId)
}

const deleteTag = async (tag?: PartiallyRequired<CategoryTag, 'id'>): Promise<void> => {
    if (!tag) return

    await popAlertConfirm({
        message: t('alert.delete.tag', { target: tag.name }),
        handler: {
            ok: () => deleteHandler(tag.id)
        }
    })
}

const addTag = async (tag?: PartiallyRequired<CategoryTag, 'id'>): Promise<void> => {
    if ((!searchAdd.value && !tag) || isDisabled.value) return

    isDisabled.value = true
    listStore.isLoaded.listItems = false

    if (tag) {
        const response = await listStore.setTag({
            tagId: tag.id,
            locationId: locationId.value,
            listId: props.listId,
            listItemId: props.listItemId
        })

        listStore.isLoaded.listItems = true
        if (!response) return

        await replaceToast({
            message: t('success.add', { target: t('target.tag') }),
            id: 'add-tag'
        })
    } else {
        const response = await listStore.createTag(locationId.value, new CategoryTag(searchAdd.value))

        if (!response) {
            isDisabled.value = false
            listStore.isLoaded.listItems = true
            return
        }

        replaceToast({
            message: t('success.create', { target: t('target.tag') }),
            id: 'create-tag'
        })
        searchAdd.value = ''

        const responseSet = await listStore.setTag({
            tagId: response.id,
            locationId: locationId.value,
            listId: props.listId,
            listItemId: props.listItemId
        })

        if (!responseSet) {
            isDisabled.value = false
            listStore.isLoaded.listItems = true
            return
        }

        listStore.getListItem(locationId.value, props.listId, props.listItemId)
    }

    listStore.isLoaded.recommendedTags = false
    await listStore.getTags(locationId.value)
    await listStore.getListItem(locationId.value, props.listId, props.listItemId)
    isDisabled.value = false
    listStore.isLoaded.listItems = true
}

const editTag = async (): Promise<void> => {
    const response = await listStore.editTag(locationId.value, tag.value)

    if (!response) return

    replaceToast({
        message: t('success.edit', { target: t('target.tag') }),
        id: 'edit-tag'
    })

    listStore.isLoaded.recommendedTags = false

    resetInput()

    await listStore.getListItem(locationId.value, props.listId, props.listItemId)

    emit('update-item')
}

const removeTag = async (tag: PartiallyRequired<CategoryTag, 'id'>): Promise<void> => {
    const response = await listStore.unsetTag({
        tagId: tag.id,
        locationId: locationId.value,
        listId: props.listId,
        listItemId: props.listItemId
    })

    if (!response) {
        listStore.isLoaded.listItems = true
        return
    }

    await listStore.getListItem(locationId.value, props.listId, props.listItemId)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonGrid), {
    class: "light-light-background purple-purple-color p-3 overflow-auto max-height-100 max-width",
    onTouchmove: _unref(stopEventAtTop)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRow), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), {
            class: "d-flex",
            style: {"gap":"10px","flex-wrap":"wrap"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listStore).productTags(__props.listId, __props.listItemId), (tag) => {
                return (_openBlock(), _createBlock(CategoryPill, {
                  class: "light-light-color",
                  key: tag.id,
                  edit: "",
                  onEdit: ($event: any) => (openEdit(tag)),
                  onRemove: ($event: any) => (removeTag(tag))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tag.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onEdit", "onRemove"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_unref(IonRow), { class: "center-y-children" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), null, {
            default: _withCtx(() => [
              _createVNode(InputSimple, {
                class: "grey4-grey4-background purple-purple-color input-padding-left",
                placeholder: _ctx.$t('placeholder.tagName'),
                modelValue: tag.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tag.value.name) = $event)),
                ref_key: "tagNameInput",
                ref: tagNameInput
              }, null, 8, ["placeholder", "modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCol), { size: "auto" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "ion-activatable round-ripple-parent p-1 square-box",
                onClick: editTag
              }, [
                _createVNode(_unref(IonIcon), { icon: _unref(checkmark) }, null, 8, ["icon"]),
                _createVNode(_unref(IonRippleEffect))
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCol), { size: "auto" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "ion-activatable round-ripple-parent p-1 square-box",
                onClick: resetInput
              }, [
                _createVNode(_unref(IonIcon), { icon: _unref(close) }, null, 8, ["icon"]),
                _createVNode(_unref(IonRippleEffect))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, showEdit.value]
      ]),
      _createVNode(_unref(IonRow), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), null, {
            default: _withCtx(() => [
              _createVNode(InputSimple, {
                modelValue: searchAdd.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchAdd).value = $event)),
                class: "grey4-grey4-background purple-purple-color card-border input-padding-left",
                placeholder: _ctx.$t('placeholder.searchOrAdd'),
                onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (addTag()), ["enter"]))
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonRow), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), { class: "center" }, {
            default: _withCtx(() => [
              _createVNode(ButtonBase, {
                class: "max-width",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (addTag())),
                disabled: !searchAdd.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('button.create')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonRow), { class: "mt-2 mb-4" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), {
            class: "d-flex",
            style: {"gap":"10px","flex-wrap":"wrap"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listStore).filterRecommended(_unref(listStore).productTags(__props.listId, __props.listItemId), searchAdd.value), (tag) => {
                return (_openBlock(), _createBlock(CategoryPill, {
                  class: "light-light-color",
                  key: tag.id,
                  onClick: ($event: any) => (addTag(tag)),
                  onDelete: ($event: any) => (deleteTag(tag)),
                  light: "",
                  "delete-able": "",
                  ripple: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tag.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "onDelete"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onTouchmove"]))
}
}

})